// Currency & macro formatters.
//
// Prices are in K IDR (thousands of rupiah) and surcharges are read off the dish
// document served by the API (`<option>_surcharge`), never hardcoded — a
// restaurant can change what oat milk costs from the back-office.
export const formatPrice = (kIDR) => `${Math.round(kIDR).toLocaleString("en-US")}K`;
export const formatPriceFull = (kIDR) => `Rp ${Math.round(kIDR).toLocaleString("en-US")}K`;

export const formatMacros = (m) =>
  `${Math.round(m.p)}P · ${Math.round(m.f)}F · ${Math.round(m.c)}C · ${Math.round(m.kcal)} kcal`;

// Option keys that can carry a surcharge. Mirrors the backend's CHOICE_OPTION_KEYS.
const CHOICE_OPTION_KEYS = ["doneness", "style", "variant", "milk"];

/** Surcharge for one chosen option, e.g. milkSurcharge(latte, "Oat +10K") -> 10. */
export const milkSurcharge = (dish, milk) => Number(dish?.milk_surcharge?.[milk] || 0);

/** Total surcharge (K IDR) for a set of chosen options on a dish. */
export const optionSurcharge = (dish, options) => {
  if (!dish || !options) return 0;
  return CHOICE_OPTION_KEYS.reduce((sum, key) => {
    const chosen = options[key];
    if (typeof chosen !== "string") return sum;
    return sum + Number(dish[`${key}_surcharge`]?.[chosen] || 0);
  }, 0);
};

/**
 * Display-only running totals for the cart. The server re-prices the order on
 * POST /api/orders — these numbers only drive the UI.
 */
export const sumMacros = (cart, findDish) => {
  return cart.reduce(
    (acc, item) => {
      const dish = findDish(item.dishId);
      if (!dish) return acc;
      const q = item.qty || 1;
      return {
        p: acc.p + (dish.p || 0) * q,
        f: acc.f + (dish.f || 0) * q,
        c: acc.c + (dish.c || 0) * q,
        kcal: acc.kcal + (dish.kcal || 0) * q,
        price: acc.price + lineItemPrice(dish, item.options, q),
      };
    },
    { p: 0, f: 0, c: 0, kcal: 0, price: 0 }
  );
};

/** Per-line price incl. any option surcharges taken from the dish document. */
export const lineItemPrice = (dish, options, qty) =>
  ((dish?.price || 0) + optionSurcharge(dish, options)) * (qty || 1);

/**
 * Drop empty option values before they go to the API — the backend rejects a
 * `null` where a real choice is expected (422).
 */
export const cleanOptions = (options) => {
  const out = {};
  Object.entries(options || {}).forEach(([key, value]) => {
    if (value === null || value === undefined || value === "") return;
    out[key] = value;
  });
  return out;
};
